import { motion } from "framer-motion";
import { cn } from "@/react/shadcn/utils";

export function OptionSkeleton({
  index,
  className,
}: {
  index: number;
  className?: string;
}) {
  return (
    <motion.div
      className={cn(
        "web3kit-animate-pulse web3kit-rounded-md web3kit-bg-foreground/10 web3kit-w-full",
        className
      )}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 * (index + 1) }}
    />
  );
}
